import Wrapper from '../../../core/wrapper';

export default {
  components: {
    Wrapper,
  },
  props: {
    background: String,
    isLoading: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    showLoading() {
      return this.isLoading && !!this.$slots.loading;
    },
  },
};
